import React, { useState, useEffect } from 'react';
import { ChevronRight, Phone, Mail, Heart, Activity, Search, Filter, AlertCircle, MessageCircle } from 'lucide-react';
import emailjs from '@emailjs/browser';

const ClinequipWebsite = () => {
  const [currentPage, setCurrentPage] = useState('home');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // ***** FIX IS HERE *****
  useEffect(() => {
    // The titles object is updated to match the new format.
    const titles = {
      home: 'Clinequip - Home',
      products: 'Clinequip - Products',
      about: 'Clinequip - About Us',
      contact: 'Clinequip - Contact Us'
    };
    // The rest of the logic correctly sets the document title.
    document.title = titles[currentPage] || 'CLINEQUIP';
  }, [currentPage]); // This effect re-runs whenever 'currentPage' changes.

  const productCatalog = {
    students: {
      name: 'Students (Medical & Nursing)',
      icon: '👨‍⚕️',
      subcategories: {
        stethoscopes: {
          name: 'Stethoscopes',
          products: [
            { id: 1, name: 'Littmann IV', price: 8500, image: '/images/students/stethoscopes/littmann-iv.jpg', description: 'Professional grade', available: true },
            { id: 2, name: 'Littmann Classic III', price: 12500, image: '/images/students/stethoscopes/littmann-iii.jpg', description: 'Premium diagnostic tool', available: true }
          ]
        },
        basicTools: {
          name: 'Basic Tools',
          products: [
            { id: 3, name: 'Reflex Hammer', price: 1500, image: '/images/students/basic-tools/reflex-hammer.jpg', description: 'Neurological tool', available: true },
            { id: 4, name: 'Rechargeable Pen Torch', price: 1200, image: '/images/students/basic-tools/rechargeable.jpg', description: 'USB rechargeable', available: true },
            { id: 5, name: 'Battery Pen Torch', price: 800, image: '/images/students/basic-tools/pen-torch-battery.jpg', description: 'Battery powered', available: true },
            { id: 6, name: 'MUAC Tape', price: 350, image: '/images/students/basic-tools/muac-tape.jpg', description: 'Measuring tape', available: true },
            { id: 7, name: 'Nurse Watch', price: 1200, image: '/images/students/basic-tools/nurse-watch.jpg', description: 'Clip-on watch', available: true },
            { id: 8, name: 'Suture Practice Kit', price: 3500, image: '/images/students/basic-tools/suture-kit.jpg', description: 'Complete practice set', available: true },
            { id: 9, name: 'Tape Measure', price: 1500, image: '/images/students/basic-tools/tape-measure.jpg', description: 'Measuring tape', available: true }
          ]
        },
        temperature: {
          name: 'Temperature Devices',
          products: [
            { id: 10, name: 'Thermogun', price: 4500, image: '/images/students/temperature/thermogun.jpg', description: 'Infrared scanner', available: true }
          ]
        },
        other: {
          name: 'Other Equipment',
          products: [
            { id: 11, name: 'Pulse Oximeter', price: 3200, image: '/images/students/other/oximeter.jpg', description: 'Fingertip device', available: true }]
            
        }
      }
    },
    wear: {
      name: 'Wear (Uniforms)',
      icon: '🥼',
      products: [ 
        { id: 12, name: 'Lab Coat', price: 2800, image: '/images/wear/lab-coat.jpg', description: 'Standard lab coat', available: true },
        { id: 13, name: 'Scrubs', price: 4500, image: '/images/wear/scrubs.jpg', description: 'Many sizes', available: true }
      ]
    },
    wardEquipment: {
      name: 'Ward Equipment',
      icon: '🏥',
      products: [
        { id: 14, name: 'BP Machine', price: 6500, image: '/images/ward/bp-machine.jpg', description: 'Digital monitor', available: true },
        { id: 15, name: 'Ripple Mattress', price: 25000, image: '/images/ward/mattress.jpg', description: 'Pressure relief', available: true },
        { id: 16, name: 'Wheelchair', price: 18000, image: '/images/ward/wheelchair.jpg', description: 'Folding wheelchair', available: true },
        { id: 17, name: 'Hospital Bed', price: 45000, image: '/images/ward/bed.jpg', description: 'Adjustable bed', available: true },
        { id: 18, name: 'Glucometer', price: 4500, image: '/images/ward/glucometer.jpg', description: 'With test strips', available: true },
        { id: 19, name: 'Commode Chair', price: 12000, image: '/images/ward/commode.jpg', description: 'Bedside commode', available: true },
        { id: 20, name: 'Walking Frame', price: 8500, image: '/images/ward/walking-frame.jpg', description: 'Adjustable aid', available: true },
        { id: 21, name: 'Splint', price: 6000, image: '/images/ward/splint.jpg', description: 'Arm splint', available: true },
        { id: 22, name: 'Massage Hammer', price: 7000, image: '/images/ward/massage-hammer.jpg', description: 'Reflex/Massage hammer', available: true },
        { id: 23, name: 'Ward Screen', price: 9000, image: '/images/ward/ward-screen.jpg', description: 'Adjustable screens', available: true }
      ]
    },
    physiotherapy: {
      name: 'Physiotherapy',
      icon: '💪',
      products: [
        { id: 24, name: 'Goniometer', price: 2800, image: '/images/physio/goniometer.jpg', description: 'Angle measurement', available: true },
        { id: 25, name: 'TENS Unit', price: 8500, image: '/images/physio/tens.jpg', description: 'Nerve stimulation', available: true },
        { id: 26, name: 'TENS EMS Combo', price: 15000, image: '/images/physio/combo.jpg', description: 'Combined therapy', available: true },
        { id: 27, name: 'Therabands', price: 1800, image: '/images/physio/therabands.jpg', description: 'Resistance bands', available: true }
      ]
    },
    clinicEssentials: {
      name: 'Clinic Essentials',
      icon: '🏨',
      products: [
        { id: 28, name: 'Syringes', price: 500, image: '/images/clinic/syringes.jpg', description: 'Various sizes', available: true },
        { id: 29, name: 'Latex Gloves', price: 1800, image: '/images/clinic/gloves.jpg', description: 'Box of 100', available: true },
        { id: 30, name: 'Surgical Masks', price: 800, image: '/images/clinic/masks.jpg', description: 'Box of 50', available: true },
        { id: 31, name: 'IV Cannulas', price: 1200, image: '/images/clinic/iv-cannulas.jpg', description: 'Various sizes', available: true },
        { id: 32, name: 'Vein Finder', price: 25000, image: '/images/clinic/vein-finder.jpg', description: 'Infrared device', available: true },
        { id: 33, name: 'MVA Kit', price: 3500, image: '/images/clinic/mva.jpg', description: 'Comprehensive kit', available: true },
        { id: 34, name: 'Vacutainers', price: 3000, image: '/images/clinic/vacutainers.jpg', description: 'Vacutainers', available: true },
        { id: 35, name: 'Crepe', price: 4000, image: '/images/clinic/crepe.jpg', description: 'Crepe bandages', available: true}
      ]
    }
  };

  const getAllProducts = () => {
    const allProducts = [];
    Object.entries(productCatalog).forEach(([catKey, category]) => {
      if (category.subcategories) {
        Object.entries(category.subcategories).forEach(([subKey, subcategory]) => {
          subcategory.products.forEach(product => {
            allProducts.push({ ...product, category: catKey, categoryName: category.name, subcategoryName: subcategory.name });
          });
        });
      } else {
        category.products.forEach(product => {
          allProducts.push({ ...product, category: catKey, categoryName: category.name });
        });
      }
    });
    return allProducts;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
    };

    try {
      await emailjs.send(
        'service_64nghib',      
        'template_vp3cont',     
        templateParams,
        'KXPme3EGFxcXqgQfG'       
      );
      alert('Thank you! Your message has been sent successfully.');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Email sending failed:', error);
      alert('Sorry, there was an error sending your message. Kindly email us directly at info@clinequip.co.ke');
    } finally {
      setIsSubmitting(false);
    }
  };

  const getFilteredProducts = () => {
    let products = getAllProducts();
    if (selectedCategory !== 'all') products = products.filter(p => p.category === selectedCategory);
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      products = products.filter(p => p.name.toLowerCase().includes(q) || p.description.toLowerCase().includes(q));
    }
    return products;
  };

  const Navbar = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
      <nav className="fixed top-0 left-0 right-0 bg-gradient-to-r from-slate-900 to-slate-800 shadow-lg z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <div className="flex items-center space-x-3 cursor-pointer" onClick={() => { setCurrentPage('home'); setMobileMenuOpen(false); }}>
              <img src="/images/logo.png" alt="CLINEQUIP Logo" className="h-12 w-12 object-contain" />
              <div>
                <h1 className="text-2xl font-bold text-white tracking-wide">CLINEQUIP</h1>
                <p className="text-xs text-teal-300">Equipping Care, Empowering Health</p>
              </div>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex space-x-8">
              {['home', 'products', 'about', 'contact'].map((page) => (
                <button
                  key={page}
                  onClick={() => { setCurrentPage(page); if (page === 'products') setSelectedCategory('all'); }}
                  className={`text-sm font-semibold uppercase tracking-wider transition-all duration-300 ${
                    currentPage === page ? 'text-teal-400 border-b-2 border-teal-400' : 'text-gray-300 hover:text-teal-300'
                  } pb-1`}
                >
                  {page === 'home' ? 'Home' : page === 'products' ? 'Products' : page === 'about' ? 'About Us' : 'Contact Us'}
                </button>
              ))}
            </div>

            {/* Mobile Menu Button */}
            <button 
              className="md:hidden text-white p-2"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                {mobileMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>

          {/* Mobile Menu Dropdown */}
          {mobileMenuOpen && (
            <div className="md:hidden mt-4 pb-4 border-t border-slate-700">
              <div className="flex flex-col space-y-4 pt-4">
                {['home', 'products', 'about', 'contact'].map((page) => (
                  <button
                    key={page}
                    onClick={() => { 
                      setCurrentPage(page); 
                      if (page === 'products') setSelectedCategory('all'); 
                      setMobileMenuOpen(false); 
                    }}
                    className={`text-left text-lg font-semibold uppercase tracking-wider transition-all duration-300 px-4 py-2 rounded ${
                      currentPage === page ? 'text-teal-400 bg-slate-700' : 'text-gray-300 hover:text-teal-300 hover:bg-slate-700'
                    }`}
                  >
                    {page === 'home' ? 'Home' : page === 'products' ? 'Products' : page === 'about' ? 'About Us' : 'Contact Us'}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </nav>
    );
  };

  return (
    <>
      <Navbar />
      <div className="pt-20">
        {/* HOME PAGE */}
        {currentPage === 'home' && (
          <div>
            <div className="bg-gradient-to-br from-teal-600 to-cyan-500 text-white py-32 px-6">
              <div className="max-w-7xl mx-auto text-center">
                <img src="/images/logo.png" alt="CLINEQUIP" className="h-32 w-32 object-contain mx-auto mb-8 animate-pulse" />
                <h1 className="text-6xl font-extrabold mb-6">Quality Medical Supplies</h1>
                <p className="text-2xl mb-8 max-w-3xl mx-auto">Equipping healthcare professionals, clinics, and training institutions with premium medical equipment, patient care essentials, and clinical supplies across Kenya.</p>
                <button onClick={() => setCurrentPage('products')} className="bg-orange-500 hover:bg-orange-600 text-white font-bold py-4 px-10 rounded-full transition-all transform hover:scale-105 shadow-2xl flex items-center mx-auto">
                  View Products <ChevronRight className="ml-2" />
                </button>
              </div>
            </div>
            
            <div className="py-20 px-6 bg-white">
              <div className="max-w-7xl mx-auto">
                <h2 className="text-4xl font-bold text-center mb-16">Why Choose CLINEQUIP?</h2>
                <div className="grid md:grid-cols-3 gap-12">
                  <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-teal-50 to-cyan-50">
                    <div className="text-5xl mb-4">✓</div>
                    <h3 className="text-2xl font-bold mb-4 text-teal-700">Quality Assured</h3>
                    <p className="text-gray-600">International medical standards</p>
                  </div>
                  <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-orange-50 to-amber-50">
                    <div className="text-5xl mb-4">⚡</div>
                    <h3 className="text-2xl font-bold mb-4 text-orange-600">Fast Delivery</h3>
                    <p className="text-gray-600">Quick delivery across Kenya</p>
                  </div>
                  <div className="text-center p-8 rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-50">
                    <div className="text-5xl mb-4">💰</div>
                    <h3 className="text-2xl font-bold mb-4 text-blue-700">Competitive Prices</h3>
                    <p className="text-gray-600">Affordable with bulk discounts</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* PRODUCTS PAGE */}
        {currentPage === 'products' && (
          <div className="min-h-screen bg-gray-50 py-24 px-6">
            <div className="max-w-7xl mx-auto">
              <h1 className="text-5xl font-extrabold mb-8 text-center">Our Products</h1>
              
              <div className="max-w-2xl mx-auto mb-8">
                <div className="relative">
                  <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input type="text" placeholder="Search products..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} className="w-full pl-12 pr-4 py-4 border-2 rounded-full focus:border-teal-500 focus:outline-none" />
                </div>
              </div>

              <div className="mb-12 flex flex-wrap justify-center gap-4">
                <button onClick={() => setSelectedCategory('all')} className={`px-6 py-3 rounded-full font-semibold ${selectedCategory === 'all' ? 'bg-teal-500 text-white' : 'bg-white text-gray-700 border-2'}`}>
                  All ({getAllProducts().length})
                </button>
                {Object.entries(productCatalog).map(([key, cat]) => (
                  <button key={key} onClick={() => setSelectedCategory(key)} className={`px-6 py-3 rounded-full font-semibold flex items-center ${selectedCategory === key ? 'bg-teal-500 text-white' : 'bg-white text-gray-700 border-2'}`}>
                    <span className="mr-2">{cat.icon}</span> {cat.name} ({getAllProducts().filter(p => p.category === key).length})
                  </button>
                ))}
              </div>

              <div className="grid md:grid-cols-4 gap-8">
                {getFilteredProducts().map((product) => (
                  <div key={product.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all transform hover:-translate-y-2 relative">
                    {!product.available && (
                      <div className="absolute top-4 right-4 z-10 bg-red-500 text-white px-3 py-1 rounded-full text-sm font-bold flex items-center">
                        <AlertCircle size={16} className="mr-1" /> Out of Stock
                      </div>
                    )}
                    {product.addon && (
                      <div className="absolute top-4 left-4 z-10 bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-bold">Add-On</div>
                    )}
                    <div className={`bg-gradient-to-br from-teal-100 to-cyan-100 h-48 flex items-center justify-center ${!product.available ? 'opacity-50' : ''}`}>
                      <img src={product.image} alt={product.name} className="w-full h-full object-cover" />
                    </div>
                    <div className="p-6">
                      {product.subcategoryName && <p className="text-xs text-teal-600 font-semibold mb-1 uppercase">{product.subcategoryName}</p>}
                      <h3 className="font-bold text-lg mb-2">{product.name}</h3>
                      <p className="text-gray-600 text-sm mb-3">{product.description}</p>
                      {/* <p className="text-2xl font-bold text-teal-600 mb-4">{formatPrice(product.price)}</p> */}
                      <button onClick={() => setCurrentPage('contact')} disabled={!product.available} className={`w-full font-semibold py-2 rounded-lg ${product.available ? 'bg-orange-500 hover:bg-orange-600 text-white' : 'bg-gray-300 text-gray-500 cursor-not-allowed'}`}>
                        {product.available ? 'Contact to Order' : 'Unavailable'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}

        {/* ABOUT PAGE */}
        {currentPage === 'about' && (
          <div className="min-h-screen bg-white py-24 px-6">
            <div className="max-w-5xl mx-auto">
              <h1 className="text-5xl font-extrabold mb-8 text-center">About CLINEQUIP</h1>
              <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-3xl p-12 shadow-xl mb-12">
                <p className="text-xl text-gray-700 mb-6">CLINEQUIP is Kenya's trusted partner in medical equipment and supplies.</p>
                <p className="text-xl text-gray-700">We understand the critical importance of quality, reliability, and affordability in healthcare equipment.</p>
              </div>
              <div className="grid md:grid-cols-2 gap-12">
                <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-10 rounded-2xl">
                  <h2 className="text-3xl font-bold mb-6 text-orange-600 flex items-center"><Heart className="mr-3" /> Our Mission</h2>
                  <p className="text-gray-700 text-lg">To equip healthcare facilities across Kenya with world-class medical supplies.</p>
                </div>
                <div className="bg-gradient-to-br from-blue-50 to-indigo-50 p-10 rounded-2xl">
                  <h2 className="text-3xl font-bold mb-6 text-blue-600 flex items-center"><Activity className="mr-3" /> Our Vision</h2>
                  <p className="text-gray-700 text-lg">To be the leading provider of medical equipment in East Africa.</p>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* CONTACT PAGE */}
        {currentPage === 'contact' && (
          <div className="min-h-screen bg-gray-50 py-24 px-6">
            <div className="max-w-6xl mx-auto">
              <h1 className="text-5xl font-extrabold mb-4 text-center">Get In Touch</h1>
              <p className="text-xl text-center mb-16">We're here to help with all your medical supply needs</p>
              
              <div className="grid md:grid-cols-2 gap-12">
                <div className="bg-white p-10 rounded-3xl shadow-2xl">
                  <h2 className="text-3xl font-bold mb-6">Send Us a Message</h2>
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                      <label className="block font-semibold mb-2">Name</label>
                      <input type="text" name="name" required value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} className="w-full px-4 py-3 border-2 rounded-lg focus:border-teal-500 focus:outline-none" placeholder="Your name" />
                    </div>
                    <div>
                      <label className="block font-semibold mb-2">Email</label>
                      <input type="email" name="email" required value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} className="w-full px-4 py-3 border-2 rounded-lg focus:border-teal-500 focus:outline-none" placeholder="your@email.com" />
                    </div>
                    <div>
                      <label className="block font-semibold mb-2">Message</label>
                      <textarea name="message" required value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} rows={5} className="w-full px-4 py-3 border-2 rounded-lg focus:border-teal-500 focus:outline-none" placeholder="Your message" />
                    </div>
                    <button 
                      type="submit" 
                      disabled={isSubmitting}
                      className="w-full bg-gradient-to-r from-teal-500 to-cyan-500 hover:from-teal-600 hover:to-cyan-600 text-white font-bold py-4 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isSubmitting ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>
                </div>

                <div>
                  <div className="bg-gradient-to-br from-teal-600 to-cyan-600 text-white p-10 rounded-3xl shadow-2xl mb-8">
                    <h2 className="text-3xl font-bold mb-8">Contact Information</h2>
                    <div className="space-y-6">
                      <div className="flex items-start">
                        <Phone className="mr-4 mt-1" size={24} />
                        <div>
                          <h3 className="font-bold text-lg mb-1">Phone / WhatsApp</h3>
                          <div className="flex items-center space-x-2 mb-2">
                            <Phone size={16} />
                            <span>+254 748 412762</span>
                          </div>
                          <div className="flex items-center space-x-2 mb-2">
                            <MessageCircle size={16} />
                            <a href="https://wa.me/254748412762" target="_blank" rel="noopener noreferrer" className="hover:underline">
                              WhatsApp: +254 748 412762
                            </a>
                          </div>
                        </div>
                      </div>
                      <div className="flex items-start">
                        <Mail className="mr-4 mt-1" size={24} />
                        <div>
                          <h3 className="font-bold text-lg mb-1">Email</h3>
                          <p>info@clinequip.co.ke</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Footer */}
      <footer className="bg-slate-900 text-white py-12 px-6">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex items-center justify-center space-x-3 mb-4">
            <img src="/images/logo.png" alt="CLINEQUIP" className="h-10 w-10 object-contain" />
            <div>
              <h3 className="text-2xl font-bold">CLINEQUIP</h3>
              <p className="text-xs text-teal-300">Equipping Care, Empowering Health</p>
            </div>
          </div>
          <p className="text-gray-400 mb-4">Your trusted partner in medical supplies</p>
          <p className="text-sm text-gray-500">© 2025 CLINEQUIP. All rights reserved.</p>
        </div>
      </footer>
    </>
  );
};

export default ClinequipWebsite;